(() => {
  if (customElements.get('lv-product-spin')) return;
  let libraryPromise;
  function library(url) {
    if (!libraryPromise) libraryPromise = new Promise((resolve, reject) => {
      const previous = window.CI360;
      const script = document.createElement('script');
      script.src = url; script.async = true;
      script.onload = () => {
        const exported = window.CI360;
        if (previous) window.CI360 = previous;
        if (exported && exported !== previous) resolve(exported); else reject(new Error('Missing viewer'));
      };
      script.onerror = () => { script.remove(); reject(new Error('Viewer load failed')); };
      document.head.append(script);
    }).catch(error => { libraryPromise = null; throw error; });
    return libraryPromise;
  }
  customElements.define('lv-product-spin', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.details = this.querySelector('details');
      this.stage = this.querySelector('.lv-spin-stage');
      this.status = this.querySelector('[data-spin-status]');
      this.controls = this.querySelector('.lv-spin-controls');
      this.range = this.querySelector('[data-spin-range]');
      this.count = this.querySelector('[data-spin-count]');
      this.generation = (this.generation || 0) + 1;
      const on = (node, event, fn) => node.addEventListener(event, fn, {signal: this.abort.signal});
      on(this.details, 'toggle', () => { if (this.details.open) this.start(); else this.stop(); });
      on(this.querySelector('[data-spin-prev]'), 'click', () => this.move(-1));
      on(this.querySelector('[data-spin-next]'), 'click', () => this.move(1));
      on(this.range, 'input', () => this.move(Number(this.range.value) - 1 - (this.view?.activeImageX || 0)));
      on(this.stage, 'keydown', event => {
        if (!this.view?.isReady) return;
        const delta = {ArrowLeft:-1,ArrowRight:1,Home:-this.view.activeImageX,End:this.view.amountX-1-this.view.activeImageX}[event.key];
        if (delta !== undefined) { event.preventDefault(); this.move(delta); }
      });
      // Use Pointer Events instead of the library's touch handler: vertical swipes remain native scrolling.
      on(this.stage, 'pointerdown', event => {
        if (!this.view?.isReady || !event.isPrimary || event.button !== 0) return;
        this.pointer = event.pointerId; this.lastX = event.clientX;
        this.stage.setPointerCapture(event.pointerId);
      });
      on(this.stage, 'pointermove', event => {
        if (this.pointer !== event.pointerId || !this.view?.isReady) return;
        const step = Math.max(5, this.stage.clientWidth / this.view.amountX);
        const frames = Math.trunc((event.clientX - this.lastX) / step);
        if (frames) { this.lastX += frames * step; this.move(frames); }
      });
      for (const name of ['pointerup','pointercancel','lostpointercapture']) on(this.stage, name, () => { this.pointer = null; });
      if (this.details.open) this.start();
    }
    async start() {
      if (this.loading || this.view) return;
      const generation = this.generation;
      this.loading = true; this.failed = false; this.status.textContent = this.dataset.loading;
      this.stage.setAttribute('aria-busy', 'true');
      const fail = () => {
        if (!this.isConnected || generation !== this.generation) return;
        this.stop(); this.status.textContent = this.dataset.error;
      };
      this.timeout = setTimeout(fail, 30000);
      try {
        const frames = JSON.parse(this.dataset.frames);
        if (!Array.isArray(frames) || frames.length < 2 || frames.length > 36) throw new Error('Invalid sequence');
        const CI360 = await library(this.dataset.library);
        if (!this.isConnected || generation !== this.generation || !this.details.open) return;
        const size = matchMedia('(max-width: 749px)').matches ? 'small' : 'large';
        // The pinned IIFE exposes an instance; module builds expose the constructor.
        const Manager = typeof CI360 === 'function' ? CI360 : CI360.constructor;
        this.manager = new Manager();
        this.view = this.manager.init(this.stage, {
          imageListX: frames.map(frame => frame[size]), amountX: frames.length,
          autoplay: false, inertia: false, lazyload: false, draggable: false, swipeable: false, keys: false,
          fullscreen: false, pinchZoom: false, zoomMax: 1, zoomControls: false, scrollHint: false,
          hints: false, bottomCircle: false, hide360Logo: true, initialIconShown: false, aspectRatio: '4 / 5',
          onReady: () => {
            if (generation !== this.generation) return;
            clearTimeout(this.timeout); this.loading = false; this.controls.hidden = false;
            this.stage.setAttribute('aria-busy', 'false'); this.status.textContent = this.dataset.ready; this.sync();
          },
          onSpin: () => this.sync(),
          onError: () => queueMicrotask(fail)
        });
      } catch { fail(); }
    }
    move(delta) {
      if (!this.view?.isReady || !delta) return;
      if (delta > 0) this.view.moveRight(false, delta); else this.view.moveLeft(false, -delta);
      this.sync();
    }
    sync() {
      if (!this.view) return;
      const current = this.view.activeImageX + 1;
      this.range.value = current; this.count.textContent = `${current} / ${this.view.amountX}`;
    }
    stop() {
      this.generation += 1; clearTimeout(this.timeout);
      const manager = this.manager;
      manager?.destroyAll(); manager?.disableMemoryManagement?.();
      // The vendor schedules automatic observation 100 ms after initialization.
      if (manager) setTimeout(() => manager.disableMemoryManagement?.(), 150);
      this.manager = null; this.view = null; this.loading = false; this.pointer = null;
      this.stage.replaceChildren(); this.stage.setAttribute('aria-busy', 'false'); this.controls.hidden = true;
    }
    disconnectedCallback() { this.abort?.abort(); this.stop(); }
  });
})();
